import { call, put, takeLatest } from 'redux-saga/effects';

import { Document, DocumentTypes } from '@models/Document';
import { DocumentApi } from '@apis/DocumentApi';
import { SagaPayload } from '@utils/typescript';
import { Pagination } from '@models/Pagination';
import { takeLatestByKey } from '@utils/saga';

import {
  documentsFetch,
  DocumentsFetchPayload,
  documentCreate,
  DocumentCreatePayload,
  stateUpdate,
  StateUpdatePayload,
  stateReload,
  StateReloadPayload,
} from './action';

function* handleDocumentsFetch({ payload }: SagaPayload<DocumentsFetchPayload>) {
  const documentType = payload.documentType as DocumentTypes;
  const state: StateUpdatePayload = { documentType, documents: null, pagination: undefined };
  try {
    const [documents, pagination] = (yield call(DocumentApi.getAll, payload)) as [Document[], Pagination];
    state.documents = documents;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleDocumentCreate({ payload }: SagaPayload<DocumentCreatePayload>) {
  const documentType = payload.documentType as DocumentTypes;
  try {
    yield call(DocumentApi.create, payload);
    const reloadPayload: StateReloadPayload = { documentType };
    yield put(stateReload(reloadPayload));
  } catch { }
}

export default function* () {
  yield takeLatest(documentCreate, handleDocumentCreate);
  yield takeLatestByKey(documentsFetch, ({ payload }) => payload.documentType, handleDocumentsFetch);
}
